import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { hapticImpact } from '@/shared/lib/telegram';

import styles from './Button.module.scss';

type Variant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  disabled,
  className,
  onClick,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={clsx(
        styles.button,
        styles[variant],
        fullWidth && styles.fullWidth,
        className,
      )}
      disabled={disabled ?? loading}
      aria-busy={loading}
      onClick={(event) => {
        hapticImpact('light');
        onClick?.(event);
      }}
      {...rest}
    >
      {loading ? <span className={styles.spinner} aria-hidden /> : null}
      <span className={clsx(loading && styles.hiddenLabel)}>{children}</span>
    </button>
  );
}
